import React, { useContext, useMemo } from 'react';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import SalesOverviewTopChartCo from './SalesOverviewTopChartCo';
import { usePcRevenueSelectorMap } from '@/pages/dashboard/filterPageComponents/monetization/hooks';
import { formatNum, formatPercentNum, getIsErrorValue } from '@/pages/dashboard/utils/utils';
import { getLocale } from 'umi';

const SalesOverviewTopChartContext = (props: any) => {
  const { config, data: apiData, secTitle } = props;
  const { chart, title, defaultSorted, sortValue } = config|| {};
  const { by_type: byType } = apiData || {};
  const  { filterVal } = useContext(FilterContext);
  const { selector } = filterVal || {};
  const isEN = getLocale() === 'en-US';
  const { getPcRevenueSelectorText } = usePcRevenueSelectorMap(selector);

  const selectedTitle = title.filter((val: { type: string; })=> val.type === byType)[0];
  const firstHeader = isEN ? selectedTitle?.name : selectedTitle?.nameCn || '';
  const titleTop10 = isEN ? selectedTitle?.top10 : selectedTitle?.top10Cn || '';

  const dataList = useMemo(() => chart?.map((val: { type: string; name: string; nameCn: string; format: string; })=> {
    const { data, loading, errorMsg } = apiData?.[val.type] || {};
    const topData = data?.dwm_list?.map((item: { value: string | number; full_name: string; share_of_all: string; value_ext1: string | number; share_of_all_ext1: string; }) => ({
      ...item,
      num: formatNum(item?.value, false, val?.format !== 'money'),
      name: getPcRevenueSelectorText(byType, item.full_name) || '',
      percentage: getIsErrorValue(item?.share_of_all) ? '-' : formatPercentNum(parseFloat(item.share_of_all?.trim()), 1),
      num_ext1: formatNum(item?.value_ext1, false, val?.format === 'money'),
      percentage_ext1: getIsErrorValue(item?.share_of_all_ext1) ? '-' : formatPercentNum(parseFloat(item.share_of_all_ext1?.trim()), 1),
      format: val?.format || 'number'
    }));
    // 和产品确认后，大于10并且others不为空的时候展示others
    const othersItem = topData?.filter((item: { full_name: string; })=>item?.full_name?.toLowerCase() === 'others') || [];
    const othersIsNull = othersItem?.[0]?.value === '';
    const isMoreThanTen = topData?.length > 10;
    const dataArr = (!othersIsNull && isMoreThanTen) ? topData : topData?.filter((item: { full_name: string; })=>item?.full_name?.toLowerCase() !== 'others') || [];

    return {
      title: val.type,
      listHeader: isEN ? val.name : val.nameCn,
      isLoading: loading,
      isError: errorMsg !== '',
      isNoData: dataArr?.length === 0,
      list: dataArr || []
    };
  }) || [], [apiData, byType, chart, getPcRevenueSelectorText, isEN]); 

  return (
    <>
      <SalesOverviewTopChartCo
        data={dataList}
        byType={byType}
        title={ titleTop10}
        firstHeader={firstHeader}
        config={config}
        defaultSortedVal={defaultSorted}
        sortValue={sortValue}
        secTitle={secTitle}
      />
    </>
  );
};

export default SalesOverviewTopChartContext;